/* PostcodeLookup/index.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	check_outros,
	create_component,
	destroy_component,
	detach,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import { onDestroy, getContext, createEventDispatcher } from "svelte";
import { getTarget } from "../targets";
import Input from "./Input.svelte";
import Select from "./Select.svelte";

function create_if_block(ctx) {
	let current;

	const select = new Select({
			props: {
				classNames: /*classNames*/ ctx[2].select,
				onSelected: /*handleSelected*/ ctx[3],
				addresses: /*response*/ ctx[0].listAddresses()
			}
		});

	return {
		c() {
			create_component(select.$$.fragment);
		},
		m(target, anchor) {
			mount_component(select, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const select_changes = {};
			if (dirty & /*response*/ 1) select_changes.addresses = /*response*/ ctx[0].listAddresses();
			select.$set(select_changes);
		},
		i(local) {
			if (current) return;
			transition_in(select.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(select.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(select, detaching);
		}
	};
}

function create_fragment(ctx) {
	let t;
	let if_block_anchor;
	let current;

	const input = new Input({
			props: {
				classNames: /*classNames*/ ctx[2].input,
				onLookup: /*handleLookup*/ ctx[4]
			}
		});

	let if_block = !/*target*/ ctx[1] && /*response*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			create_component(input.$$.fragment);
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(input, target, anchor);
			insert(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!/*target*/ ctx[1] && /*response*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
					transition_in(if_block, 1);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(input.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(input.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(input, detaching);
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { getClient } = $$props;
	const { selectTarget, classNames = {} } = getContext("style") || {};
	const dispatch = createEventDispatcher();
	let address = null;
	let response = null;
	let selectComponent;

	const unmountSelectComponent = () => {
		if (selectComponent) {
			selectComponent.$destroy();
		}
	};

	const handleSelected = value => {
		address = response.formatAddress(value);
		dispatch("address", address);
	};

	const handleLookup = async value => {
		$$invalidate(0, response = await getClient().getPostcode(value));

		if (target) {
			unmountSelectComponent();

			selectComponent = new Select({
					target,
					props: {
						onSelected: handleSelected,
						addresses: response.listAddresses()
					}
				});
		}
	};

	onDestroy(() => unmountSelectComponent());

	$$self.$set = $$props => {
		if ("getClient" in $$props) $$invalidate(5, getClient = $$props.getClient);
	};

	let target;
	$: $$invalidate(1, target = getTarget(selectTarget));
	return [response, target, classNames, handleSelected, handleLookup, getClient];
}

class Index extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { getClient: 5 });
	}
}

export default Index;